// extracted by mini-css-extract-plugin
export var VisitSpecificDirections = "VisitSpecificDirections-module--VisitSpecificDirections--6aff3";
export var image = "VisitSpecificDirections-module--image--a3956";
export var textContent = "VisitSpecificDirections-module--textContent--dda50";